module.exports = __webpack_public_path__ + "img/highlight_red.4c1e94a0.svg";